module.exports = __webpack_public_path__ + "img/bz.cd7c15c0.svg";